import axios, { AxiosPromise } from 'axios';

export const getModulos = (
  includeExterno: boolean = false
): AxiosPromise<any> =>
  axios.get(
    `/painel-api/api/usuario/me/modulos?includeExterno=${includeExterno}`
  );

export const favoritarModulo = (modulo: string): AxiosPromise<any> =>
  axios.put(`/painel-api/api/usuario/me/modulo/favoritar/${modulo}`);

export const desfavoritarModulo = (modulo: string): AxiosPromise<any> =>
  axios.delete(`/painel-api/api/usuario/me/modulo/desfavoritar/${modulo}`);
